import { FC, PropsWithChildren, ReactNode } from 'react';

import { Title } from '@hh.ru/magritte-ui';

import styles from './styles.less';

interface EmptyStateTemplateProps {
    title: string;
    description?: ReactNode;
}

const EmptyStateTemplate: FC<PropsWithChildren<EmptyStateTemplateProps>> = ({ title, description, children }) => (
    <div className={styles.card}>
        <div className={styles.content}>
            <div className={styles.circles} />
            <Title size="extra-large" Element="h2" description={description} alignment="center">
                {title}
            </Title>
            {children}
        </div>
    </div>
);

export default EmptyStateTemplate;
